import { Injectable } from '@angular/core';
import { LocalStorageService } from "libraries/service/localStorage/localStorage.service";

/**
 * Easy to use storage service. Perfect for component persistent configuration.
 */
@Injectable()
export class SimpleStorageService {

  constructor(private readonly localStorageService: LocalStorageService) { }

  /**
   * Stores given object if storageKey is not null.
   * @param storageCategory Object is stored in given category to avoid colision. Each component class should provide a unique category.
   * @param storageKey The storage key to use. If null, object is NOT stored.
   * @param objectToStore A json-serializable object/primitive to store.
   */
  public store<T>(storageCategory: string, storageKey: string|null, objectToStore: T): void {
    if (storageKey) {
      this.localStorageService.create(this.buildFullStorageKey(storageCategory, storageKey), JSON.stringify(objectToStore));
    }
  }

  /**
   * Retrieves stored object if storageKey is not null.
   * @param storageCategory Should be the same that was used in <code>store()</code>
   * @param storageKey The storage key to use. If null, object is NOT retrieved.
   * @param defaultValue
   * @return the retrieved object if any, or null
   */
  public retrieve<T>(storageCategory: string, storageKey: string|null, defaultValue?: T): T|null {
    if (!storageKey) {
      return null;
    }
    const filterAsString: string = this.localStorageService.read(this.buildFullStorageKey(storageCategory, storageKey));
    return filterAsString ? JSON.parse(filterAsString) : defaultValue ? defaultValue: null;
  }

  private buildFullStorageKey(storageCategory: string, storageKey: string): string {
    return `${storageCategory}-${storageKey}`;
  }
}
